<template>
    <v-layout justify-center>
    <v-card>
      <!--タイトル-->
          <v-card-title class="head title-center">
        {{ title }}
        <!--タイトル横アイコン-->
        <v-icon
        color="black"
        class="ml-2 mt-1">
          {{ icon }}
        </v-icon>
      </v-card-title>

    <!--概要-->
    <Summary></Summary>
    <!--メリット-->
    <Melit></Melit>
    <!--機能-->
    <Function></Function>
    <!--お問い合わせ-->
    <contact></contact>
    </v-card>
    </v-layout>
</template>

<style>
.title-center{
  justify-content: center;
}
</style>

<script>
import Summary from './Summary'
import Function from './Function'
import contact from '../contact'

export default {
  data () {
    return {
      // タイトル
      title: '診療予約システム・ワクチン予約システム',
      // タイトル横のアイコン
      icon: 'mdi-medical-bag'
    }
  },
  components: {
    Summary,
    Function,
    contact
  }
}
</script>
